import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {formatDateToLocal} from "../../../common/Helper/Support/DateTimeHelper";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import {numberFormatter} from "../../../common/Helper/Support/SettingsHelper";
import {axiosGet} from "../../../common/Helper/AxiosHelper";

export default {
    mixins: [HelperMixin, DatatableHelperMixin],
    data() {
        return {
            options: {
                name             : this.$t('finance_accounts'),
                url              : `${TENANT_BASE_URL}app/finance-accounts`,
                showHeader       : true,
                showCount        : true,
                tableShadow      : false,
                tablePaddingClass: 'pt-primary',
                columns          : [
                    {
                        title    : this.$t('actions'),
                        type     : 'action',
                        key      : 'id',
                        isVisible: true
                    },
                    {
                        title    : this.$t('name'),
                        type     : 'text',
                        key      : 'name',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('open_balance'),
                        type     : 'custom-html',
                        key      : 'balance',
                        isVisible: true,
                        modifier : (value, row) => {
                            return this.formatAccountAmount(value, row);
                        }
                    },
                    {
                        title    : this.$t('current_balance'),
                        type     : 'custom-html',
                        key      : 'current_balance',
                        isVisible: true,
                        modifier : (value, row) => {
                            return this.formatAccountAmount(value, row);
                        }
                    },
                    {
                        title    : this.$t('type'),
                        type     : 'custom-html',
                        key      : 'type',
                        isVisible: true,
                        modifier : value => {
                            return this.$t(value);
                        }
                    },
                    {
                        title    : this.$t('bank'),
                        type     : 'text',
                        key      : 'bank',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('branch'),
                        type     : 'custom-html',
                        key      : 'branch_name',
                        isVisible: true,
                        modifier : (value, row) => {
                            return value || '---';
                        }
                    },
                    {
                        title    : this.$t('audit_date'),
                        type     : 'custom-html',
                        key      : 'audit_date',
                        isVisible: true,
                        modifier : (value) => {
                            return value ? formatDateToLocal(value) : '--';
                        }
                    },
                    {
                        title    : this.$t('color'),
                        type     : 'custom-html',
                        key      : 'color',
                        isVisible: true,
                        modifier : (value) => {
                            const color = value || '#32a866';
                            return `<span class="badge badge-pill p-2 text-white" style="background-color: ${color}">${color}</span>`;
                        }
                    },
                    {
                        title    : this.$t('remark'),
                        type     : 'text',
                        key      : 'remark',
                        isVisible: true,
                    },
                ],
                filters          : [
                    {
                        title         : this.$t('search'),
                        type          : "text",
                        key           : "search",
                        placeholder   : this.$t('search')
                    },
                    {
                        title         : this.$t('bank'),
                        type          : "multi-select-filter",
                        key           : "bank",
                        option        : [],
                        listValueField: 'name',
                    },
                    {
                        title : this.$t('audit_date'),
                        type  : "range-picker",
                        key   : "audit_date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title : this.$t('created'),
                        type : "range-picker",
                        key   : "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                ],
                paginationType   : "pagination",
                responsive       : true,
                rowLimit         : 10,
                showAction       : true,
                orderBy          : 'desc',
                actionType       : 'dropdown',
                actions          : [
                    {
                        title     : this.$fieldTitle('', 'income', true),
                        icon      : 'plus',
                        type      : 'modal',
                        name      : 'add_income',
                        modifier  : row => this.$can('create_finance_transactions')
                    },
                    {
                        title     : this.$fieldTitle('', 'expense', true),
                        icon      : 'minus',
                        type      : 'modal',
                        name      : 'add_expense',
                        modifier  : row => this.$can('create_finance_transactions')
                    },
                    {
                        title     : this.$fieldTitle('', 'transfer', true),
                        icon      : 'repeat',
                        type      : 'modal',
                        name      : 'add_transfer',
                        modifier  : row => this.$can('create_finance_transfers')
                    },
                    {
                        title     : this.$t('import'),
                        icon      : 'upload',
                        type      : 'modal',
                        name      : 'import',
                        modifier  : row => this.$can('create_finance_accounts')
                    },
                    {
                        title   : this.$t('edit'),
                        icon    : 'edit',
                        type    : 'modal',
                        modifier: row => this.$can('update_finance_accounts')
                    },
                    {
                        title    : this.$t('delete'),
                        icon     : 'trash-2',
                        type     : 'modal',
                        component: 'app-confirmation-modal',
                        modalId  : 'app-confirmation-modal',
                        url      : `${TENANT_BASE_URL}app/finance-accounts/`,
                        name     : 'delete',
                        modifier : row => this.$can('delete_finance_accounts')
                    }
                ],
            }
        }
    },
    mounted() {
        const bankFilter = this.options.filters.find(item => item.key === 'bank');
        axiosGet(`${TENANT_BASE_URL}app/finance/list-bank`)
        .then(({data}) => bankFilter.option = data)
        .catch(error => this.$toastr.e(error.response.data.message));
    },
    methods: {
        formatAccountAmount(value, row = {}) {
            const settings = window.settings || {};
            const amount = numberFormatter(Number(value));
            const symbol = row.currency_symbol || settings.currency_symbol || '';
            const position = settings.currency_position || 'left';

            return this.$t(`format_${position}`, {symbol, amount});
        },
    }
}
